import React from "react";
import "./EstimateOverviewButton.css";
import { ClickAwayListener, Tooltip } from "@mui/material";
import { useGetLocalizationText } from "_store/localization/selectors";

export default function EstimateOverviewButton({
  children,
  onClick,
  hide,
  toolTipText,
  hasActionTooltip = false,
  style,
}) {
  const [open, setOpen] = React.useState(false);
  const getLocalizationText = useGetLocalizationText()

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };
  return (
    <>
      {hasActionTooltip && <ClickAwayListener onClickAway={handleTooltipClose}>
          <Tooltip
            PopperProps={{
              disablePortal: true,
              
            }}
            placement="top"
            onMouseLeave={() => setTimeout(() => {
              handleTooltipClose()
            },1500)}
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={getLocalizationText("EstimateOverview_Button_Export_Done")}
          >
            <div
              style={{ ...style }}
              title={toolTipText}
              className={
                "estimate-overview-button-container" + (hide ? " hide" : "")
              }
              onClick={() => {
                handleTooltipOpen();
                onClick();
              }}
            >
              {children}
            </div>
          </Tooltip>
      </ClickAwayListener>}
      {!hasActionTooltip && <div
        style={{ ...style }}
        title={toolTipText}
        className={"estimate-overview-button-container" + (hide ? " hide" : "")}
        onClick={onClick}
      >
        {children}
      </div>}
    </>
  );
}
